/* eslint-disable */
export default {
  attachFiles: '附加文件',
};

// @key: @#@"attachFiles"@#@ @source: @#@"Attach file"@#@
